module.exports = __webpack_public_path__ + "static/media/Shift-BoldItalic.5c3edbfd.otf";